import * as t from "react";
var e = globalThis?.document ? t.useLayoutEffect : () => {
};
export {
  e as useLayoutEffect
};
